import type { ContourProps } from './contour-definitions';
import type { Point, PointArray } from './types/contour-definition-array-type';

import { AreaContourBase } from './area-contour-base';

import { ContourBase, ContourType } from './contour-definitions';
import { processPoints } from './contour-processing/contourProcessing';
import { getClosestPointIdx } from './contour-processing/getClosestPointIdx';
import { getPointPointDistance } from './contour-processing/getPointPointDistance';

// import cv from '@techstark/opencv-js';

export class PolygonOpenContour extends AreaContourBase {
  constructor(
    props: Partial<ContourProps> & Pick<ContourProps, 'type' | 'label'>,
    polygon: PointArray = [],
  ) {
    super(props, polygon, true);

    if (props.type !== ContourType.PolygonOpenContour) {
      throw new Error('PolygonOpenContour - Invalid contour type');
    }
  }

  protected postSetPolygon(): void {
    //
  }

  protected postSetPolygonScaled(): void {
    // this._polygon = removeLoops(this._polygon);
  }

  /**
   * modifyContour
   * @param polygon PointArray to modify contour given in image coordinates
   * modifies to closed contour
   */
  public modifyContour(polygon: PointArray) {
    let modifyPointArray = processPoints(
      polygon,
      false,
      this.getImageWidth(),
      this.getImageHeight(),
    );

    for (let i = 0; i < modifyPointArray.length; i++) {
      modifyPointArray[i].x *= ContourBase.subMatrix;
      modifyPointArray[i].y *= ContourBase.subMatrix;
    }

    if (modifyPointArray.length < 3) {
      return;
    }

    let closestPointFirstIndex = getClosestPointIdx(
      modifyPointArray[0],
      this._polygon,
    );
    let closestPointLastIndex = getClosestPointIdx(
      modifyPointArray[modifyPointArray.length - 1],
      this._polygon,
    );
    const closestPointFirst = this._polygon[closestPointFirstIndex];
    const closestPointLast = this._polygon[closestPointLastIndex];

    if (closestPointFirstIndex === closestPointLastIndex) {
      return;
    }

    const distanceFirst = getPointPointDistance(
      modifyPointArray[0],
      closestPointFirst,
    );
    const distanceLast = getPointPointDistance(
      modifyPointArray[modifyPointArray.length - 1],
      closestPointLast,
    );

    // assume new end of contour
    const diff = Math.abs(distanceFirst - distanceLast);

    if (diff > 12 && (diff > distanceFirst || diff > distanceLast)) {
      if (distanceFirst >= distanceLast) {
        if (closestPointLastIndex >= this._polygon.length / 2) {
          // reverse
          modifyPointArray = [...modifyPointArray].reverse();
          // append

          this._polygon.splice(
            closestPointLastIndex,
            this._polygon.length - closestPointLastIndex,
            ...modifyPointArray,
          );
          console.log(
            'modifyContour LAX - 1',
            closestPointLastIndex,
            closestPointFirstIndex,
          );

          this.validateModifyPolygon();
          this.setPolygon(this._polygon);
        }
        else {
          // prepend
          this._polygon.splice(
            0,
            closestPointLastIndex - 1,
            ...modifyPointArray,
          );
          console.log(
            'modifyContour LAX - 2',
            closestPointLastIndex,
            closestPointFirstIndex,
          );
          this.validateModifyPolygon();
          this.setPolygon(this._polygon);
        }
      }
      else {
        if (closestPointFirstIndex >= this._polygon.length / 2) {
          // append
          this._polygon.splice(
            closestPointFirstIndex,
            this._polygon.length - closestPointFirstIndex,
            ...modifyPointArray,
          );
          console.log(
            'modifyContour LAX - 3',
            closestPointLastIndex,
            closestPointFirstIndex,
          );
          this.validateModifyPolygon();
          this.setPolygon(this._polygon);
        }
        else {
          // reverse
          modifyPointArray = [...modifyPointArray].reverse();
          // prepend
          this._polygon.splice(
            0,
            closestPointFirstIndex - 1,
            ...modifyPointArray,
          );
          console.log(
            'modifyContour LAX - 4',
            closestPointLastIndex,
            closestPointFirstIndex,
          );
          this.validateModifyPolygon();
          this.setPolygon(this._polygon);
        }
      }
      return;
    }

    if (closestPointFirstIndex > closestPointLastIndex) {
      modifyPointArray = [...modifyPointArray].reverse();
      [closestPointFirstIndex, closestPointLastIndex] = [
        closestPointLastIndex,
        closestPointFirstIndex,
      ];
      console.log(
        'modifyContour LAX - 5',
        closestPointLastIndex,
        closestPointFirstIndex,
      );
    }

    if (closestPointFirstIndex === 0) {
      // prepend
      this._polygon.splice(0, closestPointLastIndex - 1, ...modifyPointArray);
      console.log(
        'modifyContour LAX - 6',
        closestPointLastIndex,
        closestPointFirstIndex,
      );

      this.validateModifyPolygon();
      this.setPolygon(this._polygon);
      return;
    }

    if (closestPointLastIndex === this._polygon.length - 1) {
      // append
      this._polygon.splice(closestPointLastIndex, 0, ...modifyPointArray);
      console.log(
        'modifyContour LAX - 7',
        closestPointLastIndex,
        closestPointFirstIndex,
      );

      this.validateModifyPolygon();
      this.setPolygon(this._polygon);
      return;
    }
    console.log(
      'modifyContour LAX - 8',
      closestPointLastIndex,
      closestPointFirstIndex,
    );

    this._polygon.splice(
      closestPointFirstIndex,
      closestPointLastIndex - closestPointFirstIndex,
      ...modifyPointArray,
    );

    this.validateModifyPolygon();
    this.setPolygon(this._polygon);
  }

  private validateModifyPolygon() {
    for (let i = 0; i < this._polygon.length; i++) {
      this._polygon[i].x /= ContourBase.subMatrix;
      this._polygon[i].y /= ContourBase.subMatrix;
    }

    this._polygon = processPoints(
      this._polygon,
      false,
      this.getImageWidth(),
      this.getImageHeight(),
    );

    for (let i = 0; i < this._polygon.length; i++) {
      this._polygon[i].x *= ContourBase.subMatrix;
      this._polygon[i].y *= ContourBase.subMatrix;
    }
  }

  private removeDuplicatesUsingMap(points: PointArray): PointArray {
    const pointMap = new Map<string, Point>();

    points.forEach((point) => {
      const key = `${point.x},${point.y}`;
      if (!pointMap.has(key)) {
        pointMap.set(key, point); // Map stores unique keys
      }
      else {
        console.log('removeDuplicatesUsingMap - duplicate point', point);
      }
    });

    return Array.from(pointMap.values());
  }

  public getConvexHullSplineLength(debug: boolean = false): {
    hullPoints: PointArray;
    hullPerimeter: number;
  } {
    const spacing = this.getPixelSpacing();
    const sx = spacing[1] / ContourBase.subMatrix;
    const sy = spacing[0] / ContourBase.subMatrix;

    const polygon = [...this._polygon];
    const hull = AreaContourBase.convexHull(polygon);

    if (hull.length < 3) {
      return { hullPoints: hull, hullPerimeter: 0 };
    }

    const first = this._polygon[0];
    const last = this._polygon[this._polygon.length - 1];

    const firstIdx = getClosestPointIdx(first, hull);
    let lastIdx = getClosestPointIdx(last, hull);

    // If both map to the same hull vertex, nudge last to the next closest
    if (lastIdx === firstIdx) {
      let bestDist = Infinity;
      for (let i = 0; i < hull.length; i++) {
        if (i === firstIdx) continue;
        const dx = hull[i].x - last.x;
        const dy = hull[i].y - last.y;
        const d = dx * dx + dy * dy;
        if (d < bestDist) {
          bestDist = d;
          lastIdx = i;
        }
      }
    }

    const buildPath = (from: number, to: number): PointArray => {
      const path: PointArray = [];
      let i = from;
      while (true) {
        path.push(hull[i]);
        if (i === to) break;
        i = (i + 1) % hull.length;
      }
      return path;
    };

    const pathLength = (path: PointArray): number => {
      let len = 0;
      for (let i = 0; i < path.length - 1; i++) {
        len += AreaContourBase.anisotropicDist(path[i], path[i + 1], sx, sy);
      }
      return len;
    };

    const pathA = buildPath(firstIdx, lastIdx);
    const pathB = buildPath(lastIdx, firstIdx);

    // The contour side has more hull vertices than the gap side
    const openHull = pathA.length >= pathB.length ? pathA : pathB;
    const hullPerimeter
      = pathA.length >= pathB.length ? pathLength(pathA) : pathLength(pathB);

    if (debug) {
      AreaContourBase.debugDrawConvexHullSpline(
        polygon,
        openHull,
        hullPerimeter,
        false,
      );
    }

    return { hullPoints: openHull, hullPerimeter };
  }
}
